<template>
  <section>
    <div class="son_shouxin">
      <div class="title">订单数据</div>
      <div class="son_list flex">
        <div class="son_item order" v-for="(item, index) in companylist.data" :key="index">
          <div class="sonName flex ju-be">
            <span class="company bold12">{{item.title}}</span>
            <span class="mingxi" @click="mingxi(item.companyid)">查看明细</span>
          </div>
          <div class="sonData flex ju-ar">
            <li class="sonData_item">
              <span class="bold18">{{item.data.ordernum}}</span>
              <br />
              <span class="normal12">订单数量</span>
            </li>
            <li class="sonData_item">
              <span class="bold18">{{item.data.authamount}}</span>
              <br />
              <span class="normal12">订单金额</span>
            </li>
          </div>
        </div>
      </div>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="companylist.per_page"
        @current-change="currentPage"
        :total="companylist.total"
      ></el-pagination>
    </div>
    <el-dialog
      title="订单信息"
      width="60"
      :lock-scroll="true"
      :visible.sync="dialogTableVisible"
      custom-class="orderlist"
    >
      <div class="flex ju-be">
        <div class="block">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="datefrom"
            type="date"
            placeholder="选择开始日期时间"
          ></el-date-picker>
        </div>
        <div class="block">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="dateto"
            type="date"
            placeholder="选择结束日期时间"
          ></el-date-picker>
        </div>
        <el-select v-model="status" placeholder="所有订单">
          <el-option
            v-for="(item,index) in orderstatus"
            :key="index"
            :value="index"
            :label="item"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" class="exportantOrder" @click="searchReg">查询</el-button>
        <el-button
          round
          type="primary"
          size="small"
          class="exportantOrder"
          @click="exportantOrder"
        >导出订单</el-button>
      </div>
      <el-table :data="companyorderlist.data" border style=" margin: 20px auto">
        <el-table-column label="订单信息" width="160">
          <template slot-scope="scope">
            <div class="text_l">
              <div>订单号:{{ scope.row.orderno }}</div>
              <br />
              <div>{{ scope.row.addtime }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" width="60"></el-table-column>
        <el-table-column prop="amount" label="实付款" width="100"></el-table-column>
        <el-table-column label="商品信息" width="350">
          <template slot-scope="scope">
            <div class v-for="(item_i,index_i) in scope.row.detail" :key="index_i">
              <div class="clearfix cpinfo flex">
                <div class="img">
                  <a :href="'#/goodsdetail?id='+ item_i.productid" target="_blank">
                    <img :src="item_i.indexpic" style="width:80px;height:80px" />
                  </a>
                </div>
                <div class="cont ellipsis-2">
                  <div class="name">{{item_i.title}}</div>
                  <div class="info">{{item_i.specnames}}</div>
                </div>
                <div class="cart-price">{{item_i.price}}*{{item_i.num}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="statusText" label="状态"></el-table-column>
        <el-table-column prop="statusText" label="支付方式">
           <template slot-scope="scope">
<span v-if="scope.row.paymethod==2">支付宝</span> <span v-if="scope.row.paymethod==1">微信</span> <span v-else>授信</span>
          </template>
          
        </el-table-column>
        <el-table-column prop="statusText" label="结算状态">
           <template slot-scope="scope">
              <span v-if="scope.row.isauthpaid==0">未结算</span>
              <span v-if="scope.row.paymethod==1">已结算</span> 
              <span v-else>审核中</span>
          </template>
          
        </el-table-column>
      </el-table>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="companyorderlist.per_page"
        @current-change="ordercurrentorder"
        :total="companyorderlist.total"
      ></el-pagination>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: "son_shouxin",
  data() {
    return {
      page: 1,
      status:"",
      orderstatus: {
        '': "所有订单" ,
         '0': "待付款" ,
         '1': "待发货" ,
         '2': "待收货" ,
         '3':"已完成" ,
         '4': "已取消" ,
         '5': "已退款" 
      },
      datefrom: "",
      dateto: "",
      orderpage: 1,
      companyid: "",
      dialogTableVisible: false,
      companylist: {},
      companyorderlist: {}
    };
  },

  methods: {
    currentPage(e) {
      this.page = e;
      this.getcompanylist();
    },
    searchReg() {
      this.orderpage = 1;
      this.getcompanyorderlist();
    },
    async getcompanylist() {
      let companylist = await this.$fetch("shop/companylist", {
        body: { isauthpaid: "2", isexpire: "1", page: this.page, }
      });
      this.companylist = companylist;
      console.log("企业的订单数据", companylist);
    },
    async getcompanyorderlist() {
      let companyorderlist = await this.$fetch("member/suborderlist", {
        body: {
          companyid: this.companyid,
          page: this.orderpage,
          datefrom: this.datefrom,
          dateto: this.dateto,status:this.status
        }
      });
      companyorderlist.data.map(item => {
        let text = "";
        if (item.status == 0) {
          text = "待付款";
        } else if (item.status == 1) {
          text = "待发货";
        } else if (item.status == 2) {
          text = "待收货";
        } else if (item.status == 3) {
          text = "已完成";
        } else if (item.status == 4) {
          text = "已取消";
        } else if (item.status == 5) {
          text = "已退款";
        }
        item["statusText"] = text;
      });

      this.companyorderlist = companyorderlist;
      console.log("公司订单信息", companyorderlist);
    },

    async exportantOrder() {
      await this.getcompanyorderlist();
      if (this.companyorderlist.data.length == 0) {
        this.$message.error("当前状态下无订单数据");
        return;
      }
      console.log(this.datefrom, this.dateto);
      // return;
      const loading = this.$loading({
        lock: true,
        text: "导出中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let token = md5("jrsc");
      let guid = sessionStorage.guid;
      let base =
        sessionStorage.baseUrl +
        "app/member/orderlist?" +
        `token=${token}` +
        `&guid=${guid}` +
        `&page=${this.orderpage}&status=${this.status}&export=1&pagesize=${this.pagesize}&datefrom=${this.datefrom}&dateto=${this.dateto}`;
      location.href = base;
      loading.close();
    },
    async mingxi(companyid) {
      this.orderpage = 1;
      this.companyid = companyid;
      this.getcompanyorderlist();
      this.dialogTableVisible = true;
    },
    ordercurrentorder(e) {
      this.orderpage = e;
      this.getcompanyorderlist();
    }
  },

  async mounted() {
    this.getcompanylist();
  }
};
</script>

  


<style lang='scss' scoped>
.block{
  width: 200px;box-sizing: border-box;
  overflow: hidden;
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/son_order.vue